import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

@observer
class QuestionOption extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            updated: new Date(),
        }
    }

    toggle = () => {
        const { open } = this.state
        this.setState({ open: !open })
    }

    renderOption = (label, id, option, questionTypeCode) => {
        const { ruleGroup, addRuleOption, showFilter } = this.props
        const isDisabled = ruleGroup.hasRule(option.id)
        const background = isDisabled ? '#FEFEFE' : '#FFF'
        const color = isDisabled ? '#BEC6CE' : undefined

        return (
            <div
                key={option.id}
                className="question_option"
                style={{
                    background,
                    color,
                    cursor: 'pointer',
                }}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (!isDisabled) {
                        addRuleOption(label, id, option, questionTypeCode)
                    }
                    if (isDisabled && showFilter) {
                        ruleGroup.removeRule(id, option.id)
                    }
                    this.setState({ updated: new Date() })
                }}
            >

                {showFilter && <i className={`${(isDisabled) ? 'fa-solid' : 'fa-light'} fa-filter`} style={{ marginRight: '5px' }} />}
                {option.label}
            </div>
        )
    }

    pageQuestions = () => {
        const { open } = this.state
        const { option, ruleGroup, filterKey } = this.props
        const isOpenEnded = filterKey === 'openEnded'
        const { pageQuestions } = option
        const showPin = R.pathOr(false, ['reportStore', 'allowPinning'], this.props)
            && ['question', 'openEnded'].includes(filterKey)
        const pinQuestion = R.pathOr(() => {}, ['reportStore', 'pinQuestion'], this.props)
        const pinnedFilterQuestion = R.pathOr('', ['reportStore', 'pinnedFilterQuestion'], this.props)

        if (!open || pageQuestions.length === 0) return null

        return (
            <div className="sub-filter">
                {pageQuestions.map(({
                    label, id, options, questionTypeCode,
                }) => (
                    <div
                        key={id}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            // gap: '7px',
                        }}
                    >
                        <span>
                            {label}
                            {showPin
                                ? (
                                    <i
                                        style={{ marginLeft: '10px', cursor: 'pointer' }}
                                        className={`${pinnedFilterQuestion === id ? 'fa-solid' : 'fa-regular'} fa-thumbtack`}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            pinQuestion(id, options, questionTypeCode, label, ruleGroup, isOpenEnded)
                                        }}
                                    />
                                )
                                : null }
                        </span>
                        <br />
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                            }}
                        >
                            {options.map((option) => this.renderOption(label, id, option, questionTypeCode))}
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    render() {
        const { option, index } = this.props
        const { open } = this.state

        const chevron = open
            ? 'fa-light fa-chevron-up'
            : 'fa-light fa-chevron-down'

        return (
            <div
                className="report-filter"
                onClick={this.toggle}
            >
                <div className="accordion">
                    <i className={chevron} />
                    <span>{option.title}</span>
                    {option.description && (
                        <span className="description">{option.description}</span>
                    )}
                </div>
                {this.pageQuestions()}
            </div>
        )
    }
}

export default QuestionOption
